import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../../constants';
import {
  LoginAuthWithCredentialsResponse,
  LoginUserIdentifier,
  OauthAEMConfig
} from '../../../../models';
import { LoginRememberMeUtilsService } from '../../login-remember-me-utils-service/login-remember-me-utils.service';

@Injectable({
  providedIn: 'root'
})
export class LoginUserIdentifierService {
  LoginUserIdentifierHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.submitIdentifier+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: LoginRememberMeUtilsService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginUserIdentifier = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    skymilesNumber: string
  ): Observable<LoginAuthWithCredentialsResponse> => {
    const getLoginAuthWithCredentialsUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginAuthWithCredentialsUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginAuthWithCredentialsUrl
      }
    ];

    const payload: LoginUserIdentifier = {
      identifier: skymilesNumber
    };

    return new ApiBuilder<
      LoginUserIdentifier,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginAuthWithCredentialsUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.LoginUserIdentifierHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_USER_IDENTIFIER_SERVICE')
      .withCredentials(true)
      .create();
  };
}
